var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-sr-database",
    clipPath: "url(#clip0_7517_22772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 17H10V19C10 19.2652 9.89464 19.5196 9.70711 19.7071C9.51957 19.8946 9.26522 20 9 20C8.73478 20 8.48043 19.8946 8.29289 19.7071C8.10536 19.5196 8 19.2652 8 19V17H6V19C6 19.2652 5.89464 19.5196 5.70711 19.7071C5.51957 19.8946 5.26522 20 5 20C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V17H3C2.20435 17 1.44129 17.3161 0.87868 17.8787C0.31607 18.4413 0 19.2044 0 20C0 20.7956 0.31607 21.5587 0.87868 22.1213C1.44129 22.6839 2.20435 23 3 23H21C21.7956 23 22.5587 22.6839 23.1213 22.1213C23.6839 21.5587 24 20.7956 24 20C24 19.2044 23.6839 18.4413 23.1213 17.8787C22.5587 17.3161 21.7956 17 21 17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21 9H10V11C10 11.2652 9.89464 11.5196 9.70711 11.7071C9.51957 11.8946 9.26522 12 9 12C8.73478 12 8.48043 11.8946 8.29289 11.7071C8.10536 11.5196 8 11.2652 8 11V9H6V11C6 11.2652 5.89464 11.5196 5.70711 11.7071C5.51957 11.8946 5.26522 12 5 12C4.73478 12 4.48043 11.8946 4.29289 11.7071C4.10536 11.5196 4 11.2652 4 11V9H3C2.20435 9 1.44129 9.31607 0.87868 9.87868C0.31607 10.4413 0 11.2044 0 12C0 12.7956 0.31607 13.5587 0.87868 14.1213C1.44129 14.6839 2.20435 15 3 15H21C21.7956 15 22.5587 14.6839 23.1213 14.1213C23.6839 13.5587 24 12.7956 24 12C24 11.2044 23.6839 10.4413 23.1213 9.87868C22.5587 9.31607 21.7956 9 21 9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21 1H10V3C10 3.26522 9.89464 3.51957 9.70711 3.70711C9.51957 3.89464 9.26522 4 9 4C8.73478 4 8.48043 3.89464 8.29289 3.70711C8.10536 3.51957 8 3.26522 8 3V1H6V3C6 3.26522 5.89464 3.51957 5.70711 3.70711C5.51957 3.89464 5.26522 4 5 4C4.73478 4 4.48043 3.89464 4.29289 3.70711C4.10536 3.51957 4 3.26522 4 3V1H3C2.20435 1 1.44129 1.31607 0.87868 1.87868C0.31607 2.44129 0 3.20435 0 4C0 4.79565 0.31607 5.55871 0.87868 6.12132C1.44129 6.68393 2.20435 7 3 7H21C21.7956 7 22.5587 6.68393 23.1213 6.12132C23.6839 5.55871 24 4.79565 24 4C24 3.20435 23.6839 2.44129 23.1213 1.87868C22.5587 1.31607 21.7956 1 21 1Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7517_22772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.062e07564599a18561744ce73fda9f0a.svg";
export { ForwardRef as ReactComponent };